export const dashHome = {
  index: {
    boxes: {
      reservas: "Rezerwacje",
      checkins: "Check-iny",
      ocupacion: "Obłożenie",
      facturacion: "Przychody",
      ingresosTotal: "Przychody łącznie",
      saldos: "Nierozliczone salda",
      solicitudes: "Zapytania AI",
      facturas: "Faktury oczekujące",
      acciones: "Oczekujące działania",
      salen: "Wyjeżdżają dzisiaj",
      llegadas: "Najbliższe przyjazdy",
      ingresosDesglose: "Struktura przychodów",
    },
    editToolbar: {
      done: "Gotowe",
      addBox: "Dodaj kafelek",
      reset: "Przywróć domyślne",
      hint: "Przeciągnij, aby przesunąć · pociągnij róg, aby zmienić rozmiar",
      allBoxesVisible: "Wszystkie kafelki są widoczne.",
      removeTitle: "Usuń",
      showOnboarding: "Pokaż powiadomienie o konfiguracji",
    },
  },
  arrivals: {
    viewAll: "Zobacz wszystkie przyjazdy",
  },
  todayLeaving: {
    title: "Goście wyjeżdżający dzisiaj",
    subtitle: "Check-outy zaplanowane na dziś.",
    empty: "Brak gości wyjeżdżających dzisiaj.",
    loading: "Wczytywanie dzisiejszych check-outów…",
    balance: "Saldo",
    balanceDueTitle: "Do zapłaty: {amount} {currency}",
    paid: "Opłacone",
    paidTitle: "Rezerwacja opłacona",
    viewAll: "Zobacz wszystkie check-outy",
  },
  mobileNotice: {
    sheetAriaLabel: "Pobierz aplikację WACheckin",
    closeAriaLabel: "Zamknij",
    title: "Wykorzystaj WACheckin w pełni",
    desc: "Panel jest zaprojektowany z myślą o <b>komputerze</b>. Na telefonie dostępne jest podsumowanie; aby wygodnie zarządzać <b>wszystkimi funkcjami</b>, prosimy otworzyć panel na komputerze lub pobrać naszą <b>aplikację</b>.",
    appStorePrefix: "Pobierz z",
    googlePlayPrefix: "Dostępne w",
    continueOnMobile: "Kontynuuj na telefonie",
  },
};
